import React from 'react';
import { FAQAccordion } from '../../components/FAQAccordion';
const faqs = [{
  question: 'What age can my child start?',
  answer: 'We accept students as young as 3 years old in our Mini Troopers program. Our standard Kids classes start at age 6.'
}, {
  question: 'Does my child need experience?',
  answer: 'Zero experience needed! Our beginner classes are welcoming and designed to teach the basics step-by-step.'
}, {
  question: 'Is martial arts safe for kids?',
  answer: 'Yes. Safety is our top priority. We use padded floors, proper safety gear, and strict supervision to ensure a safe training environment.'
}];
export function KidsMartialArtsFAQQuestions() {
  return <FAQAccordion faqs={faqs} data-id="element-2118" />;
}